var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { Box, Button, Checkbox, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import { getWebSchedule, updateWebSchedule, } from "frontend/src/api/web-schedules";
import { usePlaylists } from "frontend/src/domain/playlists";
import { useViewer } from "frontend/src/domain/session";
import { useViewerAdvertisements } from "frontend/src/domain/audio-advertisements";
import { queryClient } from "frontend/src/domain/query-client";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { paths } from "frontend/src/pages/paths";
var cacheKey = "web-schedules";
var weekdays = [
    { bit: 1, label: "Пн" },
    { bit: 2, label: "Вт" },
    { bit: 4, label: "Ср" },
    { bit: 8, label: "Чт" },
    { bit: 16, label: "Пт" },
    { bit: 32, label: "Сб" },
    { bit: 64, label: "Вс" },
];
var Days = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return (React.createElement(Box, { width: 310 }, [weekdays.slice(0, 5), weekdays.slice(5)].map(function (row, rowIndex) { return (React.createElement(Box, { key: rowIndex, display: "flex", flexWrap: "nowrap", mb: rowIndex === 0 ? 1 : 0 }, row.map(function (day) { return (React.createElement(Box, { key: day.bit, width: 58, display: "flex", alignItems: "center", flexShrink: 0 },
        React.createElement(Checkbox, { color: "primary", checked: (value & day.bit) > 0, onChange: function () {
                return onChange((value & day.bit) > 0 ? value - day.bit : value + day.bit);
            } }),
        React.createElement(Typography, { variant: "body2" }, day.label))); }))); })));
};
var emptyMusicWindow = function () { return ({
    playlistId: 0,
    daysEnabled: 127,
    timeStart: "08:00",
    timeEnd: "22:00",
    playOrder: "forward",
}); };
var emptyAdvertisement = function () { return ({
    trackId: 0,
    daysEnabled: 127,
    timeStart: "08:00",
    timeEnd: "22:00",
    repeatIntervalMinutes: 30,
    interruptPlaying: true,
}); };
var Page = function (_a) {
    var _b, _c, _d, _e;
    var initial = _a.initial;
    var history = useHistory();
    var user = useViewer().user;
    var privatePlaylists = usePlaylists({
        type: "private",
        take: 100,
        skip: 0,
        isPublished: true,
        clientId: user === null || user === void 0 ? void 0 : user.clientId,
        orderBy: "updated_at",
        orderByDirection: "desc",
    });
    var publicPlaylists = usePlaylists({
        type: "public",
        take: 100,
        skip: 0,
        isPublished: true,
        clientId: null,
        orderBy: "order",
        orderByDirection: "asc",
    });
    var advertisements = useViewerAdvertisements();
    var _f = React.useState(initial), schedule = _f[0], setSchedule = _f[1];
    React.useEffect(function () { return setSchedule(initial); }, [initial]);
    var playlists = __spreadArray(__spreadArray([], ((_c = (_b = privatePlaylists.data) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [])), ((_e = (_d = publicPlaylists.data) === null || _d === void 0 ? void 0 : _d.items) !== null && _e !== void 0 ? _e : []));
    var save = useMutation(updateWebSchedule, {
        onSuccess: function (response) {
            queryClient.invalidateQueries(cacheKey);
            queryClient.setQueryData([cacheKey, response.id], response);
        },
    });
    var setMusicWindow = function (index, patch) {
        return setSchedule(function (current) { return (__assign(__assign({}, current), { musicWindows: current.musicWindows.map(function (item, idx) {
                return idx === index ? __assign(__assign({}, item), patch) : item;
            }) })); });
    };
    var setAdvertisement = function (index, patch) {
        return setSchedule(function (current) { return (__assign(__assign({}, current), { advertisements: current.advertisements.map(function (item, idx) {
                return idx === index ? __assign(__assign({}, item), patch) : item;
            }) })); });
    };
    return (React.createElement(BusinessOwnerLayout, null,
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(TextField, { fullWidth: true, label: "Название", value: schedule.title, onChange: function (evt) {
                    return setSchedule(__assign(__assign({}, schedule), { title: evt.target.value }));
                } }),
            React.createElement(Box, { mt: 2, display: "flex" },
                React.createElement(Button, { color: "primary", variant: "contained", disabled: save.isLoading, onClick: function () { return save.mutate(schedule); } }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
                React.createElement(Box, { ml: 1 },
                    React.createElement(Button, { variant: "outlined", onClick: function () { return history.push(paths.business.owner.schedules.index()); } }, "\u041D\u0430\u0437\u0430\u0434")))),
        React.createElement(Box, { component: Paper, mt: 2, p: 2 },
            React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                React.createElement(Typography, { variant: "h6" }, "\u041C\u0443\u0437\u044B\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u043E\u043A\u043D\u0430"),
                React.createElement(Button, { startIcon: React.createElement(Add, { fontSize: "small" }), onClick: function () {
                        return setSchedule(__assign(__assign({}, schedule), { musicWindows: schedule.musicWindows.concat(emptyMusicWindow()) }));
                    } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442")),
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { width: 300 }, "\u0414\u043D\u0438"),
                        React.createElement(TableCell, { width: 110 }, "\u0421"),
                        React.createElement(TableCell, { width: 110 }, "\u0414\u043E"),
                        React.createElement(TableCell, null, "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
                        React.createElement(TableCell, null, "\u041F\u043E\u0440\u044F\u0434\u043E\u043A"),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, schedule.musicWindows.map(function (item, index) { return (React.createElement(TableRow, { key: index },
                    React.createElement(TableCell, null,
                        React.createElement(Days, { value: item.daysEnabled, onChange: function (daysEnabled) {
                                return setMusicWindow(index, { daysEnabled: daysEnabled });
                            } })),
                    React.createElement(TableCell, null,
                        React.createElement(TextField, { type: "time", value: item.timeStart, onChange: function (evt) {
                                return setMusicWindow(index, { timeStart: evt.target.value });
                            } })),
                    React.createElement(TableCell, null,
                        React.createElement(TextField, { type: "time", value: item.timeEnd, onChange: function (evt) {
                                return setMusicWindow(index, { timeEnd: evt.target.value });
                            } })),
                    React.createElement(TableCell, null,
                        React.createElement(FormControl, { fullWidth: true },
                            React.createElement(InputLabel, null, "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
                            React.createElement(Select, { value: item.playlistId || "", onChange: function (evt) {
                                    return setMusicWindow(index, {
                                        playlistId: Number(evt.target.value),
                                    });
                                } }, playlists.map(function (playlist) { return (React.createElement(MenuItem, { key: playlist.id, value: playlist.id }, playlist.title)); })))),
                    React.createElement(TableCell, null,
                        React.createElement(Select, { value: item.playOrder, onChange: function (evt) {
                                return setMusicWindow(index, {
                                    playOrder: evt.target.value,
                                });
                            } },
                            React.createElement(MenuItem, { value: "forward" }, "\u041F\u043E \u043F\u043E\u0440\u044F\u0434\u043A\u0443"),
                            React.createElement(MenuItem, { value: "random" }, "\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u043E"))),
                    React.createElement(TableCell, null,
                        React.createElement(IconButton, { size: "small", onClick: function () {
                                return setSchedule(__assign(__assign({}, schedule), { musicWindows: schedule.musicWindows.filter(function (_, idx) { return idx !== index; }) }));
                            } },
                            React.createElement(Delete, null))))); })))),
        React.createElement(Box, { component: Paper, mt: 2, p: 2 },
            React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                React.createElement(Typography, { variant: "h6" }, "\u0420\u043E\u043B\u0438\u043A\u0438"),
                React.createElement(Button, { startIcon: React.createElement(Add, { fontSize: "small" }), onClick: function () {
                        return setSchedule(__assign(__assign({}, schedule), { advertisements: schedule.advertisements.concat(emptyAdvertisement()) }));
                    } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u043E\u043B\u0438\u043A")),
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { width: 300 }, "\u0414\u043D\u0438"),
                        React.createElement(TableCell, { width: 110 }, "\u0421"),
                        React.createElement(TableCell, { width: 110 }, "\u0414\u043E"),
                        React.createElement(TableCell, { width: 320 }, "\u0420\u043E\u043B\u0438\u043A"),
                        React.createElement(TableCell, { width: 100 }, "\u0418\u043D\u0442\u0435\u0440\u0432\u0430\u043B, \u043C\u0438\u043D"),
                        React.createElement(TableCell, null, "\u041F\u0440\u0435\u0440\u044B\u0432\u0430\u0442\u044C"),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, schedule.advertisements.map(function (item, index) {
                    var _a, _b;
                    return (React.createElement(TableRow, { key: index },
                        React.createElement(TableCell, null,
                            React.createElement(Days, { value: item.daysEnabled, onChange: function (daysEnabled) {
                                    return setAdvertisement(index, { daysEnabled: daysEnabled });
                                } })),
                        React.createElement(TableCell, null,
                            React.createElement(TextField, { type: "time", value: item.timeStart, onChange: function (evt) {
                                    return setAdvertisement(index, { timeStart: evt.target.value });
                                } })),
                        React.createElement(TableCell, null,
                            React.createElement(TextField, { type: "time", value: item.timeEnd, onChange: function (evt) {
                                    return setAdvertisement(index, { timeEnd: evt.target.value });
                                } })),
                        React.createElement(TableCell, null,
                            React.createElement(FormControl, { fullWidth: true },
                                React.createElement(InputLabel, null, "\u0420\u043E\u043B\u0438\u043A"),
                                React.createElement(Select, { value: item.trackId || "", onChange: function (evt) {
                                        return setAdvertisement(index, {
                                            trackId: Number(evt.target.value),
                                        });
                                    } }, ((_a = advertisements.data) !== null && _a !== void 0 ? _a : []).map(function (track) { return (React.createElement(MenuItem, { key: track.id, value: track.id }, track.title)); })))),
                        React.createElement(TableCell, null,
                            React.createElement(TextField, { style: { width: 90 }, type: "number", value: (_b = item.repeatIntervalMinutes) !== null && _b !== void 0 ? _b : "", onChange: function (evt) {
                                    return setAdvertisement(index, {
                                        repeatIntervalMinutes: evt.target.value === ""
                                            ? null
                                            : Number(evt.target.value),
                                    });
                                } })),
                        React.createElement(TableCell, null,
                            React.createElement(Checkbox, { color: "primary", checked: item.interruptPlaying, onChange: function (evt) {
                                    return setAdvertisement(index, {
                                        interruptPlaying: evt.target.checked,
                                    });
                                } })),
                        React.createElement(TableCell, null,
                            React.createElement(IconButton, { size: "small", onClick: function () {
                                    return setSchedule(__assign(__assign({}, schedule), { advertisements: schedule.advertisements.filter(function (_, idx) { return idx !== index; }) }));
                                } },
                                React.createElement(Delete, null)))));
                }))))));
};
export var EditWebSchedulePage = function () {
    var id = useParams().id;
    var scheduleId = Number(id);
    var schedule = useQuery([cacheKey, scheduleId], function () {
        return getWebSchedule(scheduleId);
    });
    if (!schedule.data) {
        return (React.createElement(BusinessOwnerLayout, null,
            React.createElement(Box, { component: Paper, p: 2 },
                React.createElement(Typography, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430"))));
    }
    return React.createElement(Page, { initial: schedule.data });
};
